function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 483.7",
    style: {
      enableBackground: "new 0 0 1920 483.7"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "line",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 4,
      strokeMiterlimit: 10,
      strokeDasharray: 4150,
      strokeDashoffset: 4150
    },
    d: "M-0.3,410.5H122c14.6-57.3,57.3-103.3,112.8-122.2 c-23.7-19.6-39.1-51.1-39.1-86.9c0-59.5,42.6-107.6,95.3-107.6c52.6,0,95.3,48.2,95.3,107.6c0,35.7-15.5,67.3-39.1,86.9 c55.5,18.9,98.2,64.8,112.8,122.2v0.4h86.2v-0.4c14.6-57.3,57.3-103.3,112.8-122.2c-23.7-19.6-39.1-51.1-39.1-86.9 c0-59.5,42.6-107.6,95.3-107.6c52.6,0,95.3,48.2,95.3,107.6c0,35.7-15.5,67.3-39.1,86.9c55.5,18.9,98.2,64.8,112.8,122.2v0.6h86.2 v-0.6c12.3-48.4,44.6-88.7,87.8-111.4l0,0l-57.8-18.9c0,0,19.4-12,25.3-46.2c5.9-34.2,2.6-86.8,13.4-109c10.8-22.1,41-57.9,66-51.6 c10.1,2.6,20.9,6.2,28.2,6.5h14.9c6.9,0,17.9-3.9,28.2-6.5c25-6.4,55.2,29.5,66,51.6s7.5,74.8,13.4,109s25.3,46.2,25.3,46.2 l-55.2,23h1.9c39.6,23.3,69,61.7,80.6,107.3v0.6h86.2v-0.6c14.6-57.3,57.3-103.3,112.8-122.2c-23.7-19.6-39.1-51.1-39.1-86.9 c0-59.5,42.6-107.6,95.3-107.6c52.6,0,95.3,48.2,95.3,107.6c0,35.7-15.5,67.3-39.1,86.9c55.5,18.9,98.2,64.8,112.8,122.2v0.6H1920"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.da179c62.svg";
export { ForwardRef as ReactComponent };